import React from 'react';

import { formatPrice } from '~/utils/format';
import {
  KrAverageTicket,
  KrEntryTarget,
  KrInvoice,
  KrSavings,
  KrTargetAverageTicket,
  KrTargetEnrolled,
  KrTargetRevenue,
  KrTargetRevenueBars,
} from '~/components/KoroIcons';

import { Ticket } from './styles';

interface IMetrics {
  ticketsSold: number;
  revenue: number;
  averageTicket: number;
}

interface IMetricsTarget {
  registrations: number;
  revenue: number;
  averageTicket: number;
  ticketTarget: number;
  revenueTarget: number;
}

interface IDashboardTicketsProps {
  expand: boolean;
  metrics: IMetrics;
  metricsTarget: IMetricsTarget;
}

const DashboardTickets: React.FC<IDashboardTicketsProps> = ({
  expand,
  metrics,
  metricsTarget,
}) => {
  return (
    <Ticket className={`${expand ? 'd-none' : 'col-lg-6'}`}>
      <div className="row">
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-blue">
            <div className="bg-icon p-4">
              <KrInvoice color="#fff" size={32} />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">Participantes</h3>
              <p className="h3 text-white mb-0">
                {Number.isNaN(metrics.averageTicket)
                  ? 0
                  : metrics.ticketsSold.toLocaleString('pt-BR')}
              </p>
            </div>
          </div>
        </div>
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-blue">
            <div className="bg-icon p-4">
              <KrSavings color="#fff" size={32} />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">Receita</h3>
              <p className="h3 text-white mb-0">
                {formatPrice(
                  Number.isNaN(metrics.revenue) ? 0 : metrics.revenue
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-blue">
            <div className="bg-icon p-4">
              <KrTargetEnrolled color="#fff" size={32} />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">Meta de Participantes</h3>
              <p className="h3 text-white mb-0">
                {Number.isNaN(metricsTarget.registrations)
                  ? '0%'
                  : metricsTarget.registrations.toLocaleString('pt-BR')}
              </p>
            </div>
          </div>
        </div>
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-blue">
            <div className="bg-icon p-4">
              <KrTargetRevenueBars color="#fff" size={32} />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">Meta de receita</h3>
              <p className="h3 text-white mb-0">
                {formatPrice(
                  Number.isNaN(metricsTarget.revenue)
                    ? 0
                    : metricsTarget.revenue
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-orange">
            <div className="bg-icon p-4">
              <KrEntryTarget color="#fff" size={32} />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">
                % Meta de Participantes
              </h3>
              <p className="h3 text-white mb-0">
                {Number.isNaN(metricsTarget.ticketTarget)
                  ? '0%'
                  : `${metricsTarget.ticketTarget}%`}
              </p>
            </div>
          </div>
        </div>
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-orange">
            <div className="bg-icon p-4">
              <KrTargetRevenue color="#fff" size={32} />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">% Meta de receita</h3>
              <p className="h3 text-white mb-0">
                {Number.isNaN(metricsTarget.revenueTarget)
                  ? '0%'
                  : `${metricsTarget.revenueTarget}%`}
              </p>
            </div>
          </div>
        </div>
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-orange">
            <div className="bg-icon p-4">
              <KrAverageTicket color="#fff" size={32} />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">Ticket médio</h3>
              <p className="h3 text-white mb-0">
                {formatPrice(
                  Number.isNaN(metrics.averageTicket)
                    ? 0
                    : metrics.averageTicket
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="col-6 px-0 pe-3 mt-3">
          <div className="zoom d-flex aligm-items-center bg-color-orange">
            <div className="bg-icon p-4">
              <KrTargetAverageTicket
                secondaryColor="#FFA363"
                color="#fff"
                size={32}
              />
            </div>
            <div className="d-flex flex-column justify-content-center">
              <h3 className="h6 fw-normal text-white">Meta de Ticket médio</h3>
              <p className="h3 text-white mb-0">
                {formatPrice(
                  Number.isNaN(metricsTarget.averageTicket)
                    ? 0
                    : metricsTarget.averageTicket
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Ticket>
  );
};

export default DashboardTickets;
